(function () {
  'use strict';

  angular
    .module('crewPositionsReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewPositionsReport', {
        url : '/crew-positions-report',
        views : {
        	'crewPositionsReportView' : {
        		templateUrl: 'crew-positions-report/views/crew-positions-report.tpl.html',
                controller: 'CrewPositionsReportCtrl',
                controllerAs: 'crewPositionsReport'
			}
        }
      });
  }
}());
